module.exports = __webpack_public_path__ + "static/video_poster_02.3f313631.png";